import { type ColumnDef } from '@tanstack/react-table';
import { Badge, RelativeDateTime } from 'corso-admin-ui';

const idColumn = <T extends { id: number | string }>(
  overrides?: Partial<ColumnDef<T>>,
): ColumnDef<T> => ({
  accessorKey: 'id',
  header: 'ID',
  enableSorting: true,
  ...overrides,
});

const nameColumn = <T extends { name: string }>(
  overrides?: Partial<ColumnDef<T>>,
): ColumnDef<T> => ({
  accessorKey: 'name',
  header: 'Name',
  enableSorting: true,
  ...overrides,
});

const shopifyDomainColumn = <T extends { myShopifyDomain: string }>(
  overrides?: Partial<ColumnDef<T>>,
): ColumnDef<T> => ({
  accessorKey: 'myShopifyDomain',
  header: 'Shopify Domain',
  ...overrides,
});

const createdOnColumn = <T extends { createdOn: string | null }>(
  overrides?: Partial<ColumnDef<T>>,
): ColumnDef<T> => ({
  accessorKey: 'createdOn',
  header: 'Created',
  enableSorting: true,
  cell: ({ row }) =>
    row.original.createdOn ? (
      <RelativeDateTime dateTime={row.original.createdOn} />
    ) : (
      '—'
    ),
  ...overrides,
});

const storeCountColumn = <T extends { storeCount: number }>(
  overrides?: Partial<ColumnDef<T>>,
): ColumnDef<T> => ({
  accessorKey: 'storeCount',
  header: 'Store Count',
  enableSorting: true,
  cell: ({ row }) => <Badge>{row.original.storeCount}</Badge>,
  ...overrides,
});

export const sharedTableDefinitions = {
  idColumn,
  nameColumn,
  shopifyDomainColumn,
  createdOnColumn,
  storeCountColumn,
};
